module.exports = "<div class=\"widgets\">\n\n  <div class=\"row\">\n    <div class=\"col-md-8\">\n      <ba-card cardTitle=\"County List\" baCardClass=\"with-scroll\">\n        <county-list></county-list>\n      </ba-card>\n    </div>\n\n    <div class=\"col-md-4\">\n      <ba-card cardTitle=\"New County\" baCardClass=\"with-scroll\">\n        <county-form></county-form>\n      </ba-card>\n    </div>\n\n  </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/localization/components/counties/counties.component.html
// module id = 862
// module chunks = 8